module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","commonHttp"],"commonjs":"@angular/common/http","commonjs2":"@angular/common/http","amd":"@angular/common/http"}
// module id = 8
// module chunks = 0 1